import * as React from 'react';

import Grid, { GridProps } from '@mui/material/Grid';

export type AsideProps = {
  children?: React.ReactNode;
} & GridProps;

export const Aside: React.FC<AsideProps> = ({ children, ...props }) => {
  return (
    <Grid
      component="aside"
      container
      flexDirection="column"
      flexShrink={0}
      gap={3}
      size={{ md: 3, xs: 'grow' }}
      sx={{ maxWidth: '200px' }}
      {...props}
    >
      {children}
    </Grid>
  );
};
